[
  {
    "code": "LI-01",
    "name": "Balzers"
  },
  {
    "code": "LI-02",
    "name": "Eschen"
  },
  {
    "code": "LI-03",
    "name": "Gamprin"
  },
  {
    "code": "LI-04",
    "name": "Mauren"
  },
  {
    "code": "LI-05",
    "name": "Planken"
  },
  {
    "code": "LI-06",
    "name": "Ruggell"
  },
  {
    "code": "LI-07",
    "name": "Schaan"
  },
  {
    "code": "LI-08",
    "name": "Schellenberg"
  },
  {
    "code": "LI-09",
    "name": "Triesen"
  },
  {
    "code": "LI-10",
    "name": "Triesenberg"
  },
  {
    "code": "LI-11",
    "name": "Vaduz"
  }
]